export const LOGIN = 'USE_AUTH_LOGIN';
export const LOGOUT = 'USE_AUTH_LOGOUT';
export const START_AUTHENTICATION = 'USE_AUTH_START_AUTHENTICATION';
export const STOP_AUTHENTICATION = 'USE_AUTH_STOP_AUTHENTICATION';
export const ERROR = 'USE_AUTH_ERROR';
